"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmCardSquare = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
exports.SmCardSquare = (0, react_1.forwardRef)((_a, ref) => {
    var { variant, theme = 'brand', size = 'small', image, title, subtitle, icon, iconSize = 'small', disabled, onClick, className } = _a, props = __rest(_a, ["variant", "theme", "size", "image", "title", "subtitle", "icon", "iconSize", "disabled", "onClick", "className"]);
    const cardClassname = (0, classnames_1.default)('c-card -square', `-${variant}`, `-${size}`, variant === 'simple' ? `-icon__${iconSize} -${theme}` : '', { '-disabled': disabled, '-interactive': onClick }, className);
    return (react_1.default.createElement("div", Object.assign({}, props, { className: cardClassname, tabIndex: !disabled && onClick ? 0 : undefined, role: onClick ? 'button' : undefined, onClick: !disabled ? onClick : undefined }),
        variant === 'image' && react_1.default.createElement("div", { className: "c-card__header" }, image),
        react_1.default.createElement("div", { className: "c-card__main" },
            react_1.default.createElement("span", { className: "c-card__icon" }, icon),
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "c-card__title" }, title),
                variant === 'image' && subtitle && size !== 'small' && (react_1.default.createElement("p", { className: "c-card__subtitle" }, subtitle))))));
});
//# sourceMappingURL=index.js.map